import React from 'react';

const Icon = ({ size = '28', fill = 'white', ...other }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 28 28" fill="none" {...other}>
            <path
                d="M23.9 4.1c-5.468-5.467-14.332-5.467-19.8 0-5.467 5.468-5.467 14.332 0 19.8 5.468 5.467 14.332 5.467 19.8 0 5.467-5.468 5.467-14.332 0-19.8Zm-4.122 4.128c.29.29.29.76 0 1.05l-4.725 4.724 4.724 4.724a.743.743 0 0 1-1.05 1.05l-4.724-4.724-4.725 4.725a.742.742 0 0 1-1.05-1.05l4.724-4.725-4.725-4.725a.743.743 0 0 1 1.05-1.05l4.726 4.725 4.724-4.725a.744.744 0 0 1 1.05 0Z"
                fill={fill}
            />
        </svg>
    );
};
export default React.memo(Icon);
